import React, { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import "./../styles/components/categoryDropdown.css";

interface CategoryDropdownProps {
  onSelect?: (category: string) => void;
  categories?: Array<{ id: number; name: string; slug: string }>;
  selectedCategory?: string;
}

const defaultCategories = [
  ["Tất cả", "TMĐT", "Bất động sản"],
  ["Tin tức", "Giáo dục", "Ô tô – Xe cộ"],
  ["Du lịch", "Y tế", "Thời trang – Làm đẹp"],
  ["Công nghệ", "Dịch vụ", "Ẩm thực"],
  ["Tài chính", "Thẩm mỹ", "Giải trí – Thể thao"],
];

const CategoryDropdown: React.FC<CategoryDropdownProps> = ({ onSelect, categories, selectedCategory }) => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState<string>(selectedCategory || "Tất cả");
  const ref = useRef<HTMLDivElement | null>(null);

  // Cập nhật trạng thái hoạt động khi thuộc tính selectedCategory thay đổi
  useEffect(() => {
    if (selectedCategory) {
      setActive(selectedCategory);
    }
  }, [selectedCategory]);

  useEffect(() => {
    const handle = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", handle);
    return () => document.removeEventListener("mousedown", handle);
  }, []);

  const handleClick = (cat: string) => {
    setActive(cat);
    setOpen(false);
    onSelect && onSelect(cat);
  };

  // Sử dụng danh mục API nếu được cung cấp, nếu không hãy sử dụng danh mục mặc định
  const displayCategories = categories && categories.length > 0 
    ? [["Tất cả", ...categories.map(c => c.name)]]
    : defaultCategories;

  return (
    <div className="category-dropdown" ref={ref}>
      <button className="category-btn" onClick={() => setOpen((s) => !s)}>
        <span className="category-label">Danh mục</span>
        <ChevronDown size={16} />
      </button>

      {open && (
        <div className="category-menu" role="menu">
          {displayCategories.map((col, i) => (
            <div key={i} className="category-column">
              {col.map((item) => (
                <div
                  key={item}
                  className={`category-item ${active === item ? "active" : ""}`}
                  onClick={() => handleClick(item)}
                >
                  {item}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryDropdown;
